import ShoppingList from '../Widgets/Activity/ShoppingList';
import ViewsList from '../Widgets/Activity/ViewsList';

/**
 * Integrable
 *
 * This mixin should have the logic to know if the user is under an integrated insitution
 * or a standalone institution
 *
 * This type of institution can be set from plan.has_sales in the backend admin
 *
 * Important note: Please try to use this mixin on "Containers" components so we can keep
 * storybook clean and updated. this.$store references break the storybook.
 */
export default {
  name: 'Integrable',
  data() {
    let scn = 'Shopping Cart';
    if (this.$store.state.account.user.profile.ui.integrates_wishlists) {
      scn = 'Wishlist';
    }
    return {
      TAB_SHOPPING_CART: scn,
      TAB_VIEWS: 'Views',
    };
  },
  computed: {
    integratesWishlists() {
      return this.$store.state.account.user.profile.ui.integrates_wishlists;
    },
    isIntegrated() {
      return this.$store.state.account.user.profile.institution.plan.has_sales;
    },
  },
  methods: {
    userActivityTabNames() {
      let tabs = [];
      if (this.isIntegrated) {
        tabs = [
          this.TAB_SHOPPING_CART,
          this.TAB_VIEWS,
        ];
      } else {
        tabs = [
          this.TAB_VIEWS,
        ];
      }
      return tabs;
    },
    getActivityTabComponent(tabName) {
      const lookup = {};
      lookup[this.TAB_SHOPPING_CART] = ShoppingList;
      lookup[this.TAB_VIEWS] = ViewsList;
      return lookup[tabName] || ViewsList; // XXX needs better protective programming?
    },
  },
};
